<template>
    <div class="fig box_fig">
        <div v-if="empty" :style="{ width: fig_data.width, height: fig_data.height }">
            <el-empty description="No data"></el-empty>
        </div>
        <div v-else :id="random_id" :style="{ width: fig_data.width, height: fig_data.height }"></div>
        <el-dialog
            title=""
            :visible.sync="fullFlag"
            width="90%"
            top='5vh'
            ref='dialog'
            >
            <div :id="full_random_id" :style="{ width: screenWidth*0.85+'px', height: screenHeight*0.75+'px' }"></div>
        </el-dialog>   
    </div>
</template>

<script>
import * as echarts from 'echarts/core';
import {
    DatasetComponent,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    DataZoomComponent,
    TransformComponent,
    ToolboxComponent
} from 'echarts/components';
import { BarChart} from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

import {uuid,getColors,full_icons} from "@/bus.js";

echarts.use([
    DatasetComponent,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    DataZoomComponent,
    TransformComponent,
    BarChart,
    CanvasRenderer,
    UniversalTransition,
    ToolboxComponent
]);

import '@/assets/js/ecSimpleTransform.min.js'

export default {
    props: ["fig_data", "loading","empty"],
    name: 'browse',
    data: function () {
        return {
            random_id:'x',
            loading: true,
            myChart: null,
            // fig_data:{
            //     width: "400px",
            //     height: "400px",
            //     plot_data:{
            //         data:[],
            //         val_col:'',
            //         cate_col:'',
            //         detail_cols:[],
            //         title:'',
            //     }
            // },
            fullFlag:false,
            full_random_id:'y',
            fullChart:null,
            screenHeight:document.documentElement.clientHeight,
            screenWidth:document.documentElement.clientWidth,
            full_icon:full_icons['expand'],
            mini_icon:full_icons['mini']
        }
    },
    created:function(){
        this.random_id=uuid();
        this.full_random_id=uuid();
        // setTimeout(this.full_random_id=uuid(), 100);
    },
    mounted: function () {
        this.$refs.dialog.rendered=true
        this.myChart = echarts.init(document.getElementById(this.random_id));
        this.myChart.showLoading();
        var _this = this
        window.onresize = function () {
            _this.screenWidth = document.documentElement.clientWidth
            _this.screenHeight = document.documentElement.clientHeight
            if(_this.myChart!==null){
              _this.myChart.resize();
            }
            if(_this.fullChart!==null){
              _this.fullChart.resize();
            }
        }
    },

    watch: {
        loading: function () {
            this.myChart.dispose();
            this.myChart = echarts.init(document.getElementById(this.random_id));
            if (this.loading) {
                this.myChart.showLoading();
            }
            else {
                this.plot(this.fig_data.plot_data,this.myChart,this.full_icon)
            }
        }
    },

    methods: {
        plot(plot_data,chart,full_icon) {
            // myChart.dispose();
            // console.log(plot_data);
            // _rawData[0][0] = '-log10(P-value)'
            // for (var i = 1; i < _rawData.length; i++) {
            //     _rawData[i][0] = -Math.log10(_rawData[i][0]);
            // }
            var showNumber=80
            var showPercent=showNumber*100/(plot_data.data.length-1)
            var markVal=plot_data.mark_val;
            var markName=plot_data.mark_name;
            var valCol = plot_data.val_col;
            var cateCol = plot_data.cate_col;
            var nameCol = plot_data.name_col;
            var cates=[];
            let cateColIdx=plot_data.data[0].indexOf(cateCol);
            for(var i=1;i<plot_data.data.length;i++){
                cates.push(plot_data.data[i][cateColIdx]);
            }
            let colors=getColors(cates);
            // console.log(plot_data)
            // console.log(_rawData)
            // 基于准备好的dom，初始化echarts实例
            echarts.registerTransform(window.ecSimpleTransform.aggregate);
            var option = {
                textStyle:{fontFamily :"Arial",color:'#000000'},
                dataset: [
                    {
                        id: 'raw',
                        source: plot_data.data
                    }
                ],
                title: {
                    text: plot_data.title,
                    left: 'center',
                    textStyle:{fontFamily :"Arial",fontSize : 16},
                },
                tooltip: {
                    trigger: 'axis',
                    confine: true
                },

                xAxis: {
                    type: 'category',
                    // name: nameCol,
                    nameLocation: 'middle',
                    nameGap: 30,
                    axisLabel: {
                        show: true, 
                        interval: 0, 
                        rotate: 60, 
                        fontSize: 10, 
                    },
                    scale: true,
                    min:0,
                     nameTextStyle:{
                         align:'right',

                     }
                },
                yAxis: {
                    name:valCol
                },
                grid: {
                    left: '5%',
                    right: '7%',
                    bottom: '45%'
                },
                legend: {
                    top: 25,
                    left: 'center'
                    //   selected: { detail: false }
                },
                toolbox: {
                    show: true,
                    showTitle: false,
                    feature: {
                        restore: {},
                        saveAsImage: {},
                        myFull: {
                            show: true,
                            title: 'Full screen',
                            icon: full_icon,
                            onclick: (e) => {
                                this.showFullScreen(e.getOption())
                            },
                        }
                    }
                },
          // 加入交互组件
          dataZoom: [{
              type: 'inside',
              start: 0,
              end: showPercent
          }, {
              start: 0,
              end: showPercent
          }],
                series: [
                    {
                        // name: 'detail',
                        type: 'bar',
                        datasetId: 'raw',
                        colorBy:'data',
                        tooltip: {
                            trigger: 'item'
                        },
                        itemStyle: {
                            color:function(params){
                                return colors[params.dataIndex]
                            }
                        },
                        encode: {
                            x: nameCol,
                            y: valCol,
                            tooltip: plot_data.detail_cols,
                        },
                        // markLine:{
                        //     tooltip: [],
                        //     symbol:'none',
                        //     lineStyle: {
                        //         color: '#333'
                        //     },
                        //     data:[
                        //         {yAxis:markVal,name:markName}
                        //     ],
                        //     label:{
                        //         show:true,
                        //         position:"end",
                        //         formatter: markName,
                        //     }
                        // }
                    }
                ],
            };
            setTimeout(chart.setOption(option, true), 500);
            // myChart.setOption(option);
        },
        showFullScreen() {
            if (this.fullFlag) {
                this.fullFlag = false
            } else {
                this.fullFlag = true
                if(this.fullChart!=null){
                    this.fullChart.dispose();
                }
                this.fullChart = echarts.init(document.getElementById(this.full_random_id));
                this.plot(this.fig_data.plot_data,this.fullChart,this.mini_icon)
            }
        }
    }
}
</script>



<style>
</style>


// WEBPACK FOOTER //
// src/components/plot/bar.vue